export namespace cookie {
    export function Get(key: string): string    {
        var filterd = document.cookie.split(';').filter((item) => item.trim().indexOf(`${key}=`) == 0);
        if (filterd.length >= 1) {
            var splited = filterd[0].split("=");
            if (splited.length == 2) {
                return decodeURIComponent(splited[1]);
            }
            else {
                return null;
            }            
        }
        return null;
    }

    export function Set(key: string, value: string){
        document.cookie = `${key}=${encodeURIComponent(value)}; max-age=${60 * 20}; path=/`;
    }

    export function SetToJson(key: string, value: any) {
        Set(key,JSON.stringify(value)) ;
    }
    export function GetFromJson<T>(key: string): T {
        try {
            return JSON.parse(Get(key));
        }
        catch
        {
            return null;
        }
    }
}
